import { lazyPage } from 'utils/lazyPage';

export const LazyDashboardPage = lazyPage(
  () => import('pages/DashboardPage'),
  'DashboardPage',
);
